var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFewCloudsNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather-night-cloudy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,13.2a6,6,0,0,1,0-10.4,1,1,0,0,0,0-1.731,8,8,0,0,0-11.8,5.123.25.25,0,0,0,.049.212.246.246,0,0,0,.2.094H12a8.557,8.557,0,0,1,1.423.119.248.248,0,0,0,.283-.181,6,6,0,0,1,6.841-4.346.249.249,0,0,1,.138.417A8.028,8.028,0,0,0,18.5,8a7.927,7.927,0,0,0,.19,1.724.245.245,0,0,0,.046.1,8.471,8.471,0,0,1,1.513,3.127.26.26,0,0,0,.048.1q.186.23.389.445a.25.25,0,0,1-.138.417.125.125,0,0,0-.1.136c.006.049.011.1.016.148a.244.244,0,0,0,.074.155,6.554,6.554,0,0,1,.975,1.211.25.25,0,0,0,.283.107,7.98,7.98,0,0,0,1.707-.736,1,1,0,0,0,0-1.731Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.094,15.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,5.338,12.84a.249.249,0,0,1-.22.173A5.5,5.5,0,0,0,5.5,24H16a5,5,0,0,0,3.094-8.926ZM19,19a3,3,0,0,1-3,3H5.5a3.5,3.5,0,1,1,.448-6.971A1,1,0,0,0,7.064,14.2,5,5,0,0,1,17,15c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959A3.007,3.007,0,0,1,19,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsNight);
export default __webpack_public_path__ + "static/media/few_clouds_night.0c3db42430f83dd9aa0d66648c0d4f8e.svg";
export { ForwardRef as ReactComponent };